import { Link } from "react-router-dom";
import { ChefHat } from "lucide-react";

export const inputCls = "mt-1.5 w-full bg-slate-800 border border-slate-700 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-orange-500 transition-colors";
export const btnCls = "w-full bg-orange-600 hover:bg-orange-700 disabled:opacity-60 rounded-xl py-3 font-semibold flex items-center justify-center gap-2 transition-colors";

export const AuthShell = ({ title, subtitle, children }) => (
  <div className="min-h-screen bg-slate-950 text-slate-100 flex items-center justify-center px-4">
    <div className="w-full max-w-md fade-up">
      <Link to="/" className="flex items-center gap-2 justify-center mb-8">
        <div className="h-10 w-10 rounded-xl bg-orange-600 grid place-items-center">
          <ChefHat className="h-6 w-6 text-white" />
        </div>
        <span className="font-sub font-bold text-2xl">QRFoody</span>
      </Link>
      <div className="bg-slate-900 border border-slate-800 rounded-2xl p-6 sm:p-8">
        <h1 className="font-heading text-3xl font-bold">{title}</h1>
        {subtitle && <p className="text-slate-400 text-sm mt-1">{subtitle}</p>}
        <div className="mt-6">{children}</div>
      </div>
      <p className="text-center text-sm text-slate-400 mt-6">
        <Link to="/login" data-testid="back-to-login-link" className="text-orange-400 hover:text-orange-300">Back to log in</Link>
      </p>
    </div>
  </div>
);
